// extracted by mini-css-extract-plugin
export default {"infoSectionContainer":"infoSection_infoSectionContainer__d7dbr","infoSectionContent":"infoSection_infoSectionContent__3k2RN"};